<template>
  <div style="display: inline-block">
    <!-- <label class="radio-label">文件類型: </label> -->
    <el-select
      v-model="bookType"
      style="width: 120px"
      placeholder="文件類型"
      size="small"
    >
      <el-option
        v-for="item in options"
        :key="item"
        :label="item"
        :value="item"
      />
    </el-select>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: "xlsx"
    }
  },
  data() {
    return {
      options: ["xlsx", "word"] //"pdf",
    };
  },
  computed: {
    bookType: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  }
};
</script>
